export default __webpack_public_path__ + "static/media/unblock-50px-61CEF7.d67f5dc8.svg";